import { useState, useEffect } from 'react';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import { fetchAssets, fetchDirectoryAssets } from '../../../store/assets/actions';
import Alert from '@material-ui/lab/Alert';
import { getAssetUpdated } from '../../../store/global/selectors';
import FileList from './FileList';
import CreateAssetButton from './CreateAssetButton';
import { Button, Grid, Box } from '@material-ui/core';
import { setFocusElement, toggleRightDrawer } from '../../../store/global/actions';
import { getRightDrawerStatus, getBlueprintDetails, getReRender } from '../../../store/global/selectors';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import BreadCrumb from '../../atoms/breadcrumb/';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const useStyles = makeStyles({
  typography: {
    overflowWrap: 'anywhere',
  },
});

export default function ListAssets() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const assetUpdated = useSelector(getAssetUpdated);
  const reRender = useSelector(getReRender);
  const [assets, setAssets] = useState([]);
  const [columnOneAssets, setColumnOneAssets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isColumnTwoLoading, setIsColumnTwoLoading] = useState(false);
  const [isColumnThreeLoading, setIsColumnThreeLoading] = useState(false);
  const [columnOne, setColumnOne] = useState('one');
  const [columnTwo, setColumnTwo] = useState(null);
  const [columnThree, setColumnThree] = useState(null);
  const [columnTwoId, setColumnTwoId] = useState(null);
  const [columnThreeId, setColumnThreeId] = useState(null);
  const [columnTwoAssets, setColumnTwoAssets] = useState(null);
  const [columnThreeAssets, setColumnThreeAssets] = useState(null);
  const [displayFile, setDisplayFile] = useState(false);
  const [displayItem, setDisplayItem] = useState(null);
  const [displayIcon, setDisplayIcon] = useState(null);
  const rightDrawerStatus = useSelector(getRightDrawerStatus);
  const blueprintDetails = useSelector(getBlueprintDetails);
  const windowHeight = window.innerHeight;
  const windowWidth = window.innerWidth;
  const [selectedItem, setSelectedItem] = useState(null);
  let staticBC = [{ label: 'Assets', url: null }];
  const [detailsBC, setDetailsBC] = useState(staticBC);
  const [imageHeight, setImageHeight] = useState(null);
  const [imageLoading, setImageLoading] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const videos = ['.mp4', '.avi', '.mov'];
  const images = ['.jpeg', '.jpg', '.png'];

  const firstColumnHeadingItem = {
    assetName: 'Assets',
    type: 'folder',
    parent: null,
    // selected: true,
    columnHeading: true,
    blueprintId: blueprintDetails._id,
    _id: null,
  };

  useEffect(() => {
    loadList();
  }, [assetUpdated, reRender]);

  useEffect(() => {
    const immediateParent = assets.find((item) => item._id === selectedItem?.parent);

    const secondImmediateParent = assets.find((item) => item._id === immediateParent?.parent) ? assets.find((item) => item._id === immediateParent.parent) : null;

    if (secondImmediateParent) {
      setDetailsBC([...staticBC, { label: secondImmediateParent?.assetName, url: null }, { label: immediateParent?.assetName, url: null }, { label: selectedItem.assetName, url: null }]);
    } else if (immediateParent && secondImmediateParent !== null) {
      setDetailsBC([...staticBC, , { label: immediateParent?.assetName, url: null }, { label: selectedItem.assetName, url: null }]);
    } else if (immediateParent && secondImmediateParent === null && selectedItem) {
      setDetailsBC([...staticBC, , { label: immediateParent?.assetName, url: null }, { label: selectedItem.assetName, url: null }]);
    } else if (immediateParent === undefined && selectedItem !== null) {
      if(selectedItem?._id != null){
        setDetailsBC([...staticBC, { label: selectedItem?.assetName, url: null }]);
      }else{
        setDetailsBC([...staticBC]);
      }
    }

    setSelectedIds([selectedItem?._id ? selectedItem._id : null, immediateParent?._id ? immediateParent._id : null, secondImmediateParent?._id ? secondImmediateParent._id : null]);
  }, [selectedItem]);



  const loadList = async () => {
    setLoading(true);
    await dispatch(fetchAssets())
      .then((res) => {
        setAssets([...res]);
        const columnOne = res.filter((item) => item.parent === undefined || item.parent === 'null' || item.parent === '' || item.parent === null || item.parent === 'undefined');
        columnOne.unshift(firstColumnHeadingItem);
        setColumnOneAssets(columnOne);

        if (columnTwoId !== null) {
          const columnTwoItems = res.filter((item) => item.parent === columnTwoId);
          setColumnTwoAssets(columnTwoItems);
        }

        if (columnThreeId !== null) {
          const columnThreeItems = res.filter((item) => item.parent === columnThreeId);
          setColumnThreeAssets(columnThreeItems);
        }
      })
      .catch((err) => {
        setAssets([]);
        console.log('err', err);
      });
    setLoading(false);
  };

  useEffect(() => {
    setIsColumnTwoLoading(true);
    dispatch(fetchDirectoryAssets(columnTwoId)).then((res) => {
      setColumnTwoAssets(res?.data ? res?.data : []);
      setIsColumnTwoLoading(false);
    });
  }, [columnTwoId]);

  useEffect(() => {
    setIsColumnThreeLoading(true);
    dispatch(fetchDirectoryAssets(columnThreeId)).then((res) => {
      setColumnThreeAssets(res?.data ? res?.data : []);
      setIsColumnThreeLoading(false);
    });
  }, [columnThreeId]);

  const createFolder = () => {
    if (!rightDrawerStatus) dispatch(toggleRightDrawer());
    dispatch(setFocusElement({ id: null, type: 'assets_folder', parent: null }));
  };

  const NoAssetAlert = () => {
    return (
      <Grid column container xs style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: windowHeight / 3 }} spacing={2}>
        <Grid item xs>
          <Alert icon={false} severity="info">
            No assets created yet
          </Alert>
        </Grid>

        <Grid item xs className="fileUpload">
          <Box>
            {' '}
            <CreateAssetButton />{' '}
          </Box>
          &nbsp; &nbsp;
          <Box>
            <Button onClick={() => createFolder()} variant={'contained'} color={'primary'} style={{textTransform: 'capitalize'}} data-ui-tour-id="asset-create-directory-btn">
              Create Directory
            </Button>
          </Box>
        </Grid>
      </Grid>
    );
  };
 
  return (
    <>
      {loading && (
        <Grid item xs={12}>
          <Alert severity={'info'}>Loading asset list..</Alert>
        </Grid>
      )}

      {loading === false && assets.length === 0 && columnOneAssets.length < 2 && <NoAssetAlert />}

      {columnOneAssets?.length > 0 && assets?.length > 0 && loading === false && (
        <Grid id="assets-main-grid" data-ui-tour-id='assets-main-grid' row xs container style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginLeft: '20px', minHeight: '70vh' }}>
          <Grid item xs style={{ minWidth: '60%' }}>
            <div style={{ marginBottom: '20px' }}>
              <BreadCrumb items={detailsBC} isHeading={true}/>
            </div>

            <Grid xs container spacing={1} style={{ display: 'flex', flexWrap: 'nowrap', minHeight: '90%' }}>
              {columnOne === 'one' && (
                <Grid item id="asset-col1">
                  <FileList
                    assets={columnOneAssets}
                    setDisplayFile={setDisplayFile}
                    setDisplayItem={setDisplayItem}
                    setDisplayIcon={setDisplayIcon}
                    column={'one'}
                    setColumnOne={setColumnOne}
                    setColumnTwo={setColumnTwo}
                    setColumnThree={setColumnThree}
                    setColumnTwoId={setColumnTwoId}
                    setSelectedItem={setSelectedItem}
                    setImageHeight={setImageHeight}
                    setImageLoading={setImageLoading}
                    selectedIds={selectedIds}
                    selectedItem={selectedItem}
                  />
                </Grid>
              )}

              {columnTwo === 'two' && (
                <Grid item id="asset-col2">
                  {isColumnTwoLoading ? (
                    <List>
                      <ListItem disabled={true}>
                        <ListItemText primary={'Loading..'} />
                      </ListItem>
                    </List>
                  ) : (
                    <FileList
                      assets={columnTwoAssets}
                      setDisplayFile={setDisplayFile}
                      setDisplayItem={setDisplayItem}
                      setDisplayIcon={setDisplayIcon}
                      column={'two'}
                      setColumnOne={setColumnOne}
                      setColumnTwo={setColumnTwo}
                      setColumnThree={setColumnThree}
                      setColumnThreeId={setColumnThreeId}
                      setSelectedItem={setSelectedItem}
                      setImageHeight={setImageHeight}
                      setImageLoading={setImageLoading}
                      selectedIds={selectedIds}
                      selectedItem={selectedItem}
                    />
                  )}
                </Grid>
              )}

              {columnThree === 'three' && (
                <Grid item id="asset-col3">
                  {isColumnThreeLoading ? (
                    <List>
                      <ListItem disabled={true}>
                        <ListItemText primary={'Loading..'} />
                      </ListItem>
                    </List>
                  ) : (
                    <FileList
                      assets={columnThreeAssets}
                      setDisplayFile={setDisplayFile}
                      setDisplayItem={setDisplayItem}
                      setDisplayIcon={setDisplayIcon}
                      column={'three'}
                      setColumnOne={setColumnOne}
                      setColumnTwo={setColumnTwo}
                      setColumnThree={setColumnThree}
                      setSelectedItem={setSelectedItem}
                      setImageHeight={setImageHeight}
                      setImageLoading={setImageLoading}
                      selectedIds={selectedIds}
                      selectedItem={selectedItem}
                    />
                  )}
                </Grid>
              )}
            </Grid>
          </Grid>

          <Grid item xs style={{ minWidth: '40%' }}>
            {imageLoading && (
              <Grid container alignItems="center" justify="center" spacing={2}>
                <CircularProgress style={{ marginTop: windowHeight / 3, display: 'flex', alignItems: 'center', justifyContent: 'center' }} />
              </Grid>
            )}

            {displayFile && !imageLoading && (
              <Box style={{ margin: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {displayItem.status === true ? (
                  <Grid row style={{ maxWidth: '100%' }}>
                    <Grid row xs={12}>
                      <Typography align="right" className={classes.typography}>
                        {displayItem.url}
                        {console.log("DataUI--------->", {displayFile,imageLoading,displayIcon})}
                      </Typography>
                    </Grid>
                    <hr />

                    {images.some((char) => displayItem.filePath.toLowerCase().includes(char)) && (
                      <Grid row xs={12} style={{ maxWidth: '100%', display: 'flex', justifyContent: 'right' }}>
                        <img style={{ maxWidth: '80%', maxHeight: '80%', height: 'auto', marginBottom: '10px', marginTop: '30px', borderColor: 'black', borderWidth: 6 }} src={`${displayItem?.filePath}`} />
                      </Grid>
                    )}

                    {videos.some((char) => displayItem.filePath.toLowerCase().includes(char)) && (
                      <Grid row xs={12} style={{ maxWidth: '100%', display: 'flex', justifyContent: 'right' }}>
                        <video width="640" height="360" controls style={{ maxWidth: '80%', maxHeight: '80%' }}>
                          <source src={`${displayItem.filePath}`} />
                          Your browser does not support the video tag.
                        </video>
                      </Grid>
                    )}
                  </Grid>
                ) : (
                  <Grid item xs={12} alignItems="center" justify="center" style={{ display: 'flex', marginTop: windowHeight / 3 }}>
                    <Typography variant="subtitle1">File not found</Typography>
                  </Grid>
                )}
              </Box>
            )}

            {displayIcon && !imageLoading && (
              <Grid row style={{ maxWidth: '100%' }}>
                <Grid row xs={12}>
                  <Typography align="center" className={classes.typography}>
                    {displayItem?.url}
                  </Typography>
                </Grid>
                <hr />

                <Grid container alignItems="center" justify="center" spacing={2}>
                  <Grid item xs={12} alignItems="center" justify="center" style={{ display: 'flex' }}>
                    <InsertDriveFileIcon color="primary" style={{ width: '100px', height: '100px', marginTop: windowHeight / 3 }} />
                  </Grid>
                  <Grid item xs={12} alignItems="center" justify="center" style={{ display: 'flex' }}>
                    <Typography variant="subtitle1"> {displayIcon.assetName}</Typography>
                  </Grid>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
      )}
    </>
  );
}
